import type { ComponentType } from '@/components/region';
import { InsideSpaceMetadata } from '@/components/page-designer/inside-space/index';
import { LinkColumnMetadata } from '@/components/page-designer/link-column/index';
import { CategorySubmenuSlotMetadata } from '@/components/page-designer/category-submenu-slot/index';
import { MenuItemListMetadata } from '@/components/page-designer/menu-item-list/index';
import { TrendingCarouselMetadata } from '@/components/page-designer/trending-carousel/index';
import { withComponentRegionDesignMetadata } from './merge-component-region-metadata';

/** Maps component short ids (suffix after group prefix) to decorator metadata classes. */
const METADATA_CLASS_BY_SHORT_TYPE_ID: Record<string, new (...args: never[]) => unknown> = {
    insideSpace: InsideSpaceMetadata,
    linkColumn: LinkColumnMetadata,
    categorySubmenuSlot: CategorySubmenuSlotMetadata,
    menuItemList: MenuItemListMetadata,
    trendingCarousel: TrendingCarouselMetadata,
};

function resolveNestedRegionMetadataClass(typeId: string): (new (...args: never[]) => unknown) | undefined {
    const shortId = typeId.includes('.') ? typeId.slice(typeId.lastIndexOf('.') + 1) : typeId;
    return METADATA_CLASS_BY_SHORT_TYPE_ID[shortId];
}

/** Applies decorator region definitions for nested Page Designer regions in design mode. */
export function enrichComponentForNestedRegions(component: ComponentType): ComponentType {
    const metadataClass = resolveNestedRegionMetadataClass(component.typeId);

    if (!metadataClass) {
        return component;
    }

    return withComponentRegionDesignMetadata(component, metadataClass);
}
